import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { FileProvider } from '../file.provider';
import { StoredFile } from '../../model/file';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
    selector: 'file-tree-node',
    templateUrl: './file.tree.node.html',
    styleUrls: ['./file.tree.node.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    providers: [FileProvider],
    animations: [
        trigger('AnimateChildren', [
            transition(':enter', [
                style({ opacity: 0, transform: 'scaleY(0)' }),
                animate(300, style({ opacity: 1, transform: 'scaleY(1)' }))
            ]),
            transition(':leave', [
                style({ opacity: 1, transform: 'scaleY(1)' }),
                animate(300, style({ opacity: 0, transform: 'scaleY(0)'}))
            ])
        ])
    ]
})
export class FileTreeNode {

    @Output('select')
    onSelect: EventEmitter<StoredFile> = new EventEmitter();

    @Input()
    folders: StoredFile[] = [];

    @Input()
    indent: number = 0;

    // root: string = '';      //'D://';
    // path: string = '';
// @Input()
// path: string = '';

    @Input()
    resource: string = '';

    @Input()
    selected_id: number;

    @Input()
    disabled_id: number;

    @Input()
    disabled: boolean;

    isOpen: boolean = false;

    @Input()
    folder: StoredFile = null;       //'Sameh';

    constructor(private fileProvider: FileProvider) {
        // if (Math.random() > .5) {
        //     this.folders.push(new File().read({filename: 'Nour'}) );
        //     this.folders.push(new File().read({filename: 'Sirag'}) );
        // }
    }

    ngOnInit() {
        // this.reload();
    }

    reload() {
        let path = this.folder.path || '';
        if (path.length) {
            if (path.startsWith('/')) path = path.substring(1);
            if (path.length) path += '/';
        }
        path += this.folder.filename;
        // console.log(path, this.folder);

        this.fileProvider.getFolders(this.folder.id, this.resource)
        .then(data => {
            this.folders = [];
            for(let f of data) {
                if (f.isDirectory()) {
                    this.folders.push(f);
                }
            }
        });

        // this.fileProvider.exploreFiles(path, this.resource)
        // .then(data => {
        //     this.folders = [];
        //     for(let f of data) {
        //         if (f.isDirectory()) {
        //             this.folders.push(f);
        //         }
        //     }
        // });
    }

    toggle() {
        // setTimeout(() => {
            this.isOpen = !this.isOpen;

        if (this.isOpen) {
            this.reload();
        }
        // }, 300);
    }

    select(file: StoredFile) {
        if (!this.disabled && this.disabled_id != file.id) {
            this.onSelect.emit(file);
        }
    }

    childSelected(event: StoredFile) {
        // console.log("Node: ", event);
        this.onSelect.emit(event);
    }
}